<template>
  <section class="section process">
    <table-ag
      v-if="datos"
      :rowData="datos"
      :columnDefs="columns"
      :components="components"
      :component-menu="componentMenu"
      :actions="true"
      @selected="selected"
    ></table-ag>
    <!-- Components -->
    <transition name="slideCustom">
      <MenuCreateFrp
        v-if="showMenuCreate"
        :data="processEdit"
        :hasBenchmark="hasBenchmark"
        @closeMenuCreate="closeMenuCreate"
        @getProcesses="getData"
      >
      </MenuCreateFrp>
    </transition>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
import tableAg from "../dashboard/tableAg.vue";
import MenuCreateFrp from "./components/menuCreateFrp.vue";
import menuTableDataFrp from "./components/menuTableDataFrp.vue";
import buttonsActionFrsp from "./components/buttons-action.vue";

export default {
  components: {
    tableAg,
    MenuCreateFrp,
  },
  data() {
    return {
      datos: [],
      processEdit: {},
      columns: [
        {
          field: "nombre",
          headerName: "Proceso",
          editable: true,
          suppressKeyboardEvent: (params) => {
            return this.suppressEnter(params);
          },
          cellRenderer: (params) => {
            return `${this.formatTypeProcess(params)} ${params.value}`;
          },
        },
        {
          field: "status",
          headerName: "Estado",
          editable: false,
          cellRenderer: (params) => {
            return `<span class="tag is-success">${
              params.value === "creado" ? "Creado" : params.value
            }</span>`;
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "created",
          headerName: "Creación",
          editable: false,
          cellRenderer: (params) => {
            return new Date(params.value).toISOString().slice(0, 10);
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
        },
        {
          field: "_id",
          headerName: "Controles",
          hide: this.tokenUser ? this.tokenUser.cliente : true,
          colId: "_actions",
          editable: false,
          cellRenderer: "ButtonsActionFrsp",
          cellRendererParams: { tokenUser: this.tokenUser },
        },
      ],
      components: {
        ButtonsActionFrsp: () => {
          return {
            render: (h) =>
              h(buttonsActionFrsp, {
                props: {},
                on: {
                  editProcess: this.editProcess,
                },
              }),
          };
        },
      },
      componentMenu: () => {
        return {
          render: (h) =>
            h(menuTableDataFrp, {
              props: {},
              on: {
                closeMenuCreate: this.closeMenuCreate,
              },
            }),
        };
      },
      showMenuCreate: false,
    };
  },
  props: {
    tokenUser: Object,
  },
  computed: {
    ...mapState(["idtoken"]),
    hasBenchmark() {
      return this.datos.some((x) => x.benchmark === 1);
    },
  },
  methods: {
    selected(d) {
      this.$emit("selFrs", d);
    },
    async getData() {
      const _this = this;
      let result;
      try {
        result = await apiServices.get(`/frplist`);
        _this.datos = result.data.map((el) => {
          return {
            nombre: el.nombre,
            id: el._id,
            cliente: el.cliente.nombre,
            status: el.status,
            responses: el.agrupadoras,
            dataAdmin: el.data,
            benchmark: el.benchmark,
            created: el.created,
            formaIntraManual: el.formaIntraManual,
          };
        });
      } catch (err) {
        console.log(err);
      }
    },
    closeMenuCreate() {
      this.showMenuCreate = !this.showMenuCreate;
      if (!this.showMenuCreate) this.processEdit = {};
    },
    editProcess(data) {
      this.processEdit = data;
      this.closeMenuCreate();
    },
    // Helpers
    formatTypeProcess(p) {
      if (!p.data.benchmark) return "";
      return `<span class="tag tag-process is-success is-capitalized"><i class="mdi mdi-database-import-outline"></i></span>`;
    },
    suppressEnter(params) {
      const KEY_ENTER = "Enter";

      const event = params.event;
      const key = event.key;
      const suppress = key === KEY_ENTER;

      return suppress;
    },
  },
  watch: {
    idtoken(nv, ov) {
      if (nv) {
        this.getData();
      }
    },
  },
  created() {
    if (this.idtoken) {
      this.getData();
    }
  },
};
</script>
<style lang="scss">
.ag-header-cell-label {
  justify-content: center !important;
}
.slideCustom-enter {
  transform: translateX(30vw) !important;
}

.slideCustom-enter-active {
  transition: all 0.3s ease-in !important;
}

.slideCustom-leave-active {
  transition: all 0.3s ease-in !important;
}
.slideCustom-leave-to {
  transform: translateX(30vw) !important;
}

.slideCustom-two-enter {
  transform: translateX(30vw) !important;
}

.slideCustom-two-enter-active {
  transition: all 0.3s ease-in !important;
}

.slideCustom-two-leave-active {
  transition: all 0.3s ease-in !important;
}
.slideCustom-two-leave-to {
  transform: translateX(30vw) !important;
}

.process .tag-process {
  margin-right: 5px;
  height: auto !important;
  font-size: 17px !important;
  padding-left: 0.35em !important;
  padding-right: 0.35em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/DatosFrs.vue